import { Track } from '../../host/stores';

export interface Participant {
  TenantRoomId: number;
  RoomUrl: string;
  RoomType: string;
  RoomName: string;
  UserId: number;
  Moniker: string;
  Name: string;
  Email: string;
  PictureUrl: string;
  DepartmentId: number;
  DepartmentName: string;
  DomainId: number;
  DomainName: string;
  Status: string;
  isSelf: boolean;
  isScreenSharing: boolean;
  isMute: boolean;
  isCameraOn: boolean;
  isViewingScreen: boolean;
  Video: string;
}

export interface ScreenShare {
  UserId: number;
  Name: string;
  Video: string;
  PictureUrl: string;
}

export interface ScreenShareTrack {
  id: string;
  participantId: string;
  displayName: string;
  isLocal: boolean;
  track: Track;
}

export enum VIRTUAL_BACKGROUND_TYPE {
  NONE = 'none',
  IMAGE = 'image',
  BLUR = 'blur',
}
export type BlurPreset = 'slight-blur' | 'blur' | 'none';

export interface VirtualBackgroundOptions {
  backgroundEffectEnabled: boolean;
  backgroundType?: VIRTUAL_BACKGROUND_TYPE; // BLUR | IMAGE | NONE
  virtualSource?: string; // image URL / data URL if IMAGE
  blurValue?: number; // e.g., 8 or 25 for BLUR
  selectedThumbnail?: string; // UI hint: 'blur' | 'slight-blur' | 'none' | image id
}
